import { useContext, useMemo } from 'react'

import { SanityRelatedProductsModule } from '@data/sanity/queries/types/modules'
import { StringsContext } from '@lib/strings-context'

import ProductCarousel from '@blocks/shop/product-carousel'

type RelatedProductsProps = Pick<
  SanityRelatedProductsModule,
  'products' | 'backupProducts'
> & {
  className?: string
}

const limit = 4

const RelatedProducts = ({
  products,
  backupProducts,
  className,
}: RelatedProductsProps) => {
  const strings = useContext(StringsContext)

  const concatenatedProducts = useMemo(() => {
    const baseProducts = products ?? []
    const additionalProducts = backupProducts ?? []

    if (baseProducts.length >= limit) {
      return baseProducts.slice(0, limit)
    }

    return [
      ...baseProducts,
      ...additionalProducts.slice(0, limit - baseProducts.length),
    ]
  }, [backupProducts, products])

  return (
    <ProductCarousel
      title={strings.productRelatedProducts}
      products={concatenatedProducts}
      className={className}
    />
  )
}

export default RelatedProducts
